import Actions from '../../odata/actions';

const actions = new Actions('extensionFeedback', 'extensionFeedbacks');

export default actions;
